export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '6416b82', dateTime: 1781197757566 };